import Vue from 'vue';
import VueRouter, { NavigationGuardNext, Route } from 'vue-router';

import ReposTable from '@/components/ReposTable.vue';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: ReposTable,
    beforeEnter: async (to: Route, from: Route, next: NavigationGuardNext) => {
      await store.dispatch('authorize');
      next();
    }
  },
  { path: '*', redirect: '/' }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
